import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import type { PromoteVariationTo } from 'model/JCE-methods/types';

/**
 * Create the promoteVariation method.
 */
export function createPromoteVariation(context: API.Context) {
  /**
   * Promote a variation.
   */
  return function promoteVariation(
    lineId: number,
    promoteTo: PromoteVariationTo,
    options: { replace: boolean } = { replace: false },
  ): API.Response {
    const { game, respond } = context;

    // attempt to promote
    const promoted = game.promoteVariation(lineId, promoteTo);

    if (!promoted) {
      return null;
    }

    if (options.replace) {
      // JCE swaps the indexes, so we can use lineId to delete the demoted line
      game.deletePosition(-1, lineId);
    }

    return respond(Core.APIEvents.PromoteVariation);
  };
}
